// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 991px) {
  .contactContent {
    flex-direction: column;
    margin-top: 25%;
    margin-top: 30px;
  }

  .contactForm {
    flex: 1;
    padding: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  form {
    width: 100%;
    padding: 24px;
    /* box-shadow: 0px 0px 20px #ddd; */
    /* background-color: #f1f1f1; */
  }

  form h2 {
    text-align: center;
  }

  .contactLinks {
    padding: 24px;
    margin-top: 10%;
  }

  #aboutPara {
    width: 100%;
  }

  .socialcontainer button {
    width: 58px;
    height: 58px;
    margin: 6px;
  }
}

@media screen and (min-width: 992px) {
  .contactContent {
    flex-direction: row;
    margin-top: 100px;
  }

  .contactForm {
    flex: 1;
    padding: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  form {
    width: 520px;
    padding: 48px;
    /* background-color: #f1f1f1; */
    box-shadow: 0px 0px 20px #ddd;
  }

  .contactLinks {
    padding: 48px;
    border-style: solid;
    border-left-width: 1px;
    border-right-width: 0px;
    border-top-width: 0px;
    border-bottom-width: 0px;
    border-color: #ddd;
  }

  #aboutPara {
    width: 80%;
    line-height: 32px;
    margin-top: 24px;
    color: #555;
  }

  .socialcontainer button {
    width: 58px;
    height: 58px;
    margin: 6px;
  }
}

.contactContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
}

.contactHeading {
  width: 100%;
  padding: 12px;
  /* margin-top: 2%; */
  text-align: center;
  font-size: 3rem;
  font-weight: 500;
}

.underline {
  width: 15%;
  height: 2px;
  background-color: #ccc;
}

.contactContent {
  display: flex;
}

.contactLinks {
  flex: 1;
}

form h2 {
  margin-bottom: 52px;
  color: #555;
}

.formRow {
  margin-top: 24px;
}

.formRow button {
  width: 100%;
  background-color: #56acb7;
  border: none;
  padding: 12px;
}

.formRow button:hover {
  background-color: #255a61;
}`, "",{"version":3,"sources":["webpack://./src/components/contact/Contact.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mCAAmC;IACnC,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,OAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@media screen and (max-width: 991px) {\n  .contactContent {\n    flex-direction: column;\n    margin-top: 25%;\n    margin-top: 30px;\n  }\n\n  .contactForm {\n    flex: 1;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  form {\n    width: 100%;\n    padding: 24px;\n    /* box-shadow: 0px 0px 20px #ddd; */\n    /* background-color: #f1f1f1; */\n  }\n\n  form h2 {\n    text-align: center;\n  }\n\n  .contactLinks {\n    padding: 24px;\n    margin-top: 10%;\n  }\n\n  #aboutPara {\n    width: 100%;\n  }\n\n  .socialcontainer button {\n    width: 58px;\n    height: 58px;\n    margin: 6px;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .contactContent {\n    flex-direction: row;\n    margin-top: 100px;\n  }\n\n  .contactForm {\n    flex: 1;\n    padding: 48px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  form {\n    width: 520px;\n    padding: 48px;\n    /* background-color: #f1f1f1; */\n    box-shadow: 0px 0px 20px #ddd;\n  }\n\n  .contactLinks {\n    padding: 48px;\n    border-style: solid;\n    border-left-width: 1px;\n    border-right-width: 0px;\n    border-top-width: 0px;\n    border-bottom-width: 0px;\n    border-color: #ddd;\n  }\n\n  #aboutPara {\n    width: 80%;\n    line-height: 32px;\n    margin-top: 24px;\n    color: #555;\n  }\n\n  .socialcontainer button {\n    width: 58px;\n    height: 58px;\n    margin: 6px;\n  }\n}\n\n.contactContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n}\n\n.contactHeading {\n  width: 100%;\n  padding: 12px;\n  /* margin-top: 2%; */\n  text-align: center;\n  font-size: 3rem;\n  font-weight: 500;\n}\n\n.underline {\n  width: 15%;\n  height: 2px;\n  background-color: #ccc;\n}\n\n.contactContent {\n  display: flex;\n}\n\n.contactLinks {\n  flex: 1;\n}\n\nform h2 {\n  margin-bottom: 52px;\n  color: #555;\n}\n\n.formRow {\n  margin-top: 24px;\n}\n\n.formRow button {\n  width: 100%;\n  background-color: #56acb7;\n  border: none;\n  padding: 12px;\n}\n\n.formRow button:hover {\n  background-color: #255a61;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
